import angular from "angular"

const templateUrl = require("ngtemplate-loader!html-loader!./tab-datos.component.html")

angular.module("fichaAlumnoModule").component("tabDatos", {
  templateUrl: templateUrl,
  bindings: {
    datasource: "<",
    fields: "<",
    indicadores: "<"
  },

  controller: function TabDatosController($http) {
    var self = this

    self.numberWithCommas = function(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }

    self.numberToCurrency = function(x) {
      return "$" + self.numberWithCommas(x)
    }

    self.customFilter = function(dato) {
      var value = self.datasource[dato.value]
      if (!!dato.currency) {
        return self.numberToCurrency(value)
      }

      if (!!dato.cedula) {
        return self.numberWithCommas(value)
      }

      return value
    }
  }
})
